import UserIcon from "@redotech/redo-icons/user-01.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import {
  AdvancedTableFilter,
  ArrayStringTableFilter,
} from "@redotech/redo-web/advanced-filters/advanced-filter";

export const CustomerNameFilter = (
  fetcher: (
    { filters }: { filters: AdvancedTableFilter[] },
    signal: AbortSignal,
  ) => Promise<string[]>,
): ArrayStringTableFilter<string> => ({
  type: AdvancedFilterType.ARRAY_TO_STRING,
  data: {
    name: "customer",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "customer",
  Icon: UserIcon,
  operators: [
    ArrayStringFilterOperator.NONE_OF,
    ArrayStringFilterOperator.ALL_OF,
    ArrayStringFilterOperator.ANY_OF,
  ],
  valueFetcher: fetcher,
  dbSearch: true,
  displayName: "Customer name",
});
